import React from 'react';

const HREF = 'https://douto.app/neurologia/?utm_source=glasgow&utm_medium=calculadora&utm_campaign=result&utm_content=escala_adulto';

export default function DoutoResultCta() {
  return (
    <aside className="douto-result" aria-label="Douto, apoio à decisão clínica">
      <div>
        <p className="douto-result__eyebrow">Próximo passo · Douto</p>
        <h3>Precisa organizar a dúvida clínica depois de avaliar a Escala de Glasgow?</h3>
        <p>Converse sobre o caso com referências e limites explícitos. O primeiro caso é grátis; se decidir contratar, você tem 7 dias de garantia.</p>
      </div>
      <a href={HREF} data-th-event="douto_cta_click">Perguntar ao Douto <span aria-hidden="true">→</span></a>
    </aside>
  );
}
